import { UserDefaultIcon } from '@practium/ui';

export const companyAnalysisChartData = [
	{ month: '01', realizado: 45, planejado: 40 },
	{ month: '02', realizado: 52, planejado: 45 },
	{ month: '03', realizado: 48, planejado: 50 },
	{ month: '04', realizado: 58, planejado: 52 },
	{ month: '05', realizado: 62, planejado: 55 },
	{ month: '06', realizado: 70, planejado: 60 },
	{ month: '07', realizado: 65, planejado: 68 },
	{ month: '08', realizado: 72, planejado: 70 },
	{ month: '09', realizado: 78, planejado: 72 },
	{ month: '10', realizado: 75, planejado: 78 },
	{ month: '11', realizado: 85, planejado: 80 },
	{ month: '12', realizado: 92, planejado: 85 },
];

export const companyAnalysisChartConfig = {
	title: 'Análises Processadas',
	mainValue: '- Análises',
	trendValue: '- %',
	trendLabel: 'vs ano anterior',
	trendDirection: 'up' as const,
	footerText: 'Análises de solo e foliar de Jan-Dez, ' + new Date().getFullYear(),
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
	xAxisKey: 'month',
	bar1Key: 'realizado',
	bar1Label: 'Realizado',
	bar2Key: 'anoAnterior',
	bar2Label: 'ano anterior',
};

export const companyTeamDonutData = [
	{ name: 'Agricultores', value: 0, color: 'var(--chart-donut-dark)' },
	{ name: 'Consultores', value: 0, color: 'var(--chart-donut-medium)' },
	{ name: 'Inativos', value: 0, color: 'var(--chart-donut-light)' },
];

export const companyTeamDonutConfig = {
	title: 'Equipe e Clientes',
	subtitle: 'Usuários vinculados à empresa',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const companyRecommendationsChartData = [
	{ name: 'Geradas', value: 0 },
	{ name: 'Em Andamento', value: 0 },
	{ name: 'Implementadas', value: 0 },
];

export const companyRecommendationsChartConfig = {
	title: 'Recomendações Agronômicas',
	subtitle: 'Status das recomendações geradas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const companyPropertiesData = [
	{ id: 1, name: 'Fazenda São José', value: '- ha', icon: UserDefaultIcon },
	{ id: 2, name: 'Sítio Boa Vista', value: '- ha', icon: UserDefaultIcon },
	{ id: 3, name: 'Fazenda Santa Clara', value: '- ha', icon: UserDefaultIcon },
	{ id: 4, name: 'Chácara Esperança', value: '- ha', icon: UserDefaultIcon },
];

export const companyPropertiesConfig = {
	title: 'Maiores Propriedades',
	subtitle: 'Propriedades gerenciadas pela empresa',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const companyConsultantActivityData = [
	{ day: '01', current: 32, previous: 28 },
	{ day: '02', current: 38, previous: 32 },
	{ day: '03', current: 42, previous: 35 },
	{ day: '04', current: 36, previous: 40 },
	{ day: '05', current: 45, previous: 38 },
	{ day: '06', current: 48, previous: 42 },
];

export const companyConsultantActivityConfig = {
	title: 'Atividade dos Consultores',
	mainValue: '- Atendimentos',
	trendValue: '- %',
	trendLabel: 'vs semana anterior',
	trendDirection: 'up' as const,
	footerText: '',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
	xAxisKey: 'day',
	line1Key: 'current',
	line1Label: 'Semana atual',
	line2Key: 'previous',
	line2Label: 'Semana anterior',
	tooltipTitle: 'Atendimentos',
};
